import { useEffect, useLayoutEffect, useRef, useState } from "react";
import "./styles.css";
import {
    checkAndSetStats,
    isMobileUserAgent,
} from "../../helpers/helpers";
import { Sidebar } from "primereact/sidebar";
import ContactMeBlock from "../../components/ContactMeBlock";
import { BreadCrumb } from "primereact/breadcrumb";
import { get, ref } from "firebase/database";
import { database } from "../../firebase";
import ProductLuxury from "../../components/ProductLuxury";
import debounce from "lodash/debounce";
import FilterComponent from "../../components/FilterComponent";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import AllFilterIndicators from "../../components/AllFilterIndicators";
import Footer from "../../components/Footer";
import Navigation from "../../components/Navigation";
import SEO from "../../components/SEO";

function Catalog() {
    const doesStatsSent = useRef(false);
    const [filtersVisible, setFiltersVisible] = useState(false);
    const [contactVisible, setContactVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isProductsLoading, setIsProductsLoading] = useState(true);
    const [allProducts, setAllProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [materialType, setMaterialType] = useState([]);
    const [productType, setProductType] = useState([]);
    const [insertType, setInsertType] = useState([]);
    const [collectionType, setCollectionType] = useState([]);
    const [priceMinMax, setPriceMinMax] = useState([]);

    const [priceFilter, setPriceFilter] = useState([]);
    const [materialFilter, setMaterialFilter] = useState([]);
    const [productTypeFilter, setProductTypeFilter] = useState([]);
    const [insertTypeFilter, setInsertTypeFilter] = useState([]);
    const [collectionTypeFilter, setCollectionTypeFilter] = useState([]);

    const isPriceFilterActive =
        priceFilter[0] !== priceMinMax[0] || priceFilter[1] !== priceMinMax[1];
    const isMaterialFilterActive = materialFilter.length;
    const isProductTypeFilterActive = productTypeFilter.length;
    const isInsertTypeFilterActive = insertTypeFilter.length;
    const isCollectionTypeFilterActive = collectionTypeFilter.length;
    // const isAnyFilterActive =
    //     isPriceFilterActive ||
    //     isMaterialFilterActive ||
    //     productTypeFilter.length;

    const isMobile = isMobileUserAgent();

    const getUniqueArrayWithSet = (arr) => {
        return [...new Set(arr)];
    };

    const findMinMax = (arr) => {
        if (arr.length === 0) {
            return [];
        }

        const min = Math.min(...arr);
        const max = Math.max(...arr);

        return [min, max];
    };

    useLayoutEffect(() => {
        document.body.style.backgroundColor = "#1D1D1D";
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    });

    useEffect(() => {
        if (!doesStatsSent.current) {
            checkAndSetStats("catalogPage");
            doesStatsSent.current = true;
        }
    }, []);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });

        const dbRefTotal = ref(database, `/`);

        get(dbRefTotal)
            .then((snapshot) => {
                if (snapshot.exists()) {
                    const prices = [];
                    const materialTypes = [];
                    const productTypes = [];
                    const insertTypes = [];
                    const collectionTypes = [];
                    const productsList = [
                        ...snapshot.val()?.BILLION.products,
                        ...snapshot.val()?.CVD.products,
                        ...snapshot.val()?.airGold.products,
                        ...snapshot.val()?.harmony.products,
                        ...snapshot.val()?.kolorovi.products,
                        ...snapshot.val()?.reflect.products,
                        ...snapshot.val()?.vidrodzhennya.products,
                    ].filter((item) => item);

                    productsList.forEach((item) => {
                        prices.push(item.price);
                        materialTypes.push(item?.materialType);
                        productTypes.push(item?.productType);
                        collectionTypes.push(item?.collection);
                        insertTypes.push(
                            item?.insertType === "-"
                                ? "Без вставок"
                                : item?.insertType
                        );
                    });

                    setAllProducts(productsList);
                    setFilteredProducts(productsList);
                    setPriceFilter(findMinMax(prices));
                    setPriceMinMax(findMinMax(prices));
                    setMaterialType(getUniqueArrayWithSet(materialTypes));
                    setProductType(getUniqueArrayWithSet(productTypes));
                    setInsertType(getUniqueArrayWithSet(insertTypes));
                    setCollectionType(getUniqueArrayWithSet(collectionTypes));
                } else {
                    console.log("No data available");
                }
            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => {
                setIsLoading(false);
                setIsProductsLoading(false);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const replaceMetalDesignations = (text) => {
        let newText = text.replace(/Золото 585°/g, "Золота");
        newText = newText.replace(/Срібло 925°/g, "Срібла");
        return newText;
    };

    const filterProducts = (
        priceRange = [],
        materialTypes = [],
        productTypes = [],
        insertTypes = [],
        collectionTypes = []
    ) => {
        let filteredProducts = [...allProducts]; // Создаем копию исходного массива

        // 1. Фильтрация по цене
        if (priceRange.length === 2) {
            const [minPrice, maxPrice] = priceRange;
            filteredProducts = filteredProducts.filter((product) => {
                const productPrice = product.price || 0;
                return productPrice >= minPrice && productPrice <= maxPrice;
            });
        }

        // 2. Фильтрация по типу материала
        if (materialTypes.length > 0) {
            filteredProducts = filteredProducts.filter((product) => {
                const productMaterialType = product.materialType;
                return materialTypes.includes(productMaterialType);
            });
        }

        // 3. Фильтрация по типу продукта
        if (productTypes.length > 0) {
            filteredProducts = filteredProducts.filter((product) => {
                const productType = product.productType;
                return productTypes.includes(productType);
            });
        }

        // 4. Фильтрация по типу вставки
        if (insertTypes.length > 0) {
            filteredProducts = filteredProducts.filter((product) => {
                const insertType = product.insertType;
                return insertTypes.includes(
                    insertType === "-" ? "Без вставок" : insertType
                );
            });
        }

        // 5. Фильтрация по типу коллекции
        if (collectionTypes.length > 0) {
            filteredProducts = filteredProducts.filter((product) => {
                const collectionType = product.collection;
                return collectionTypes.includes(collectionType);
            });
        }

        setFilteredProducts(filteredProducts);
    };

    const debouncedFilter = debounce(filterProducts, 500);

    const items = [
        {
            label: materialFilter.length
                ? `Прикраси із ${materialFilter
                      .map((item) => replaceMetalDesignations(item))
                      .join(", ")}`
                : "Каталог",
        },
    ];
    const home = {
        label: "TSATSKY",
        url: "/",
    };

    return (
        <div className="bg-white catalog">
            <SEO
                title="Каталог"
                description="Каталог ювелірних виробів TSATSKY. Золоті та срібні каблучки, сережки, підвіски, браслети. Фільтруйте за матеріалом, типом виробу та ціною."
                url="/catalog"
                productList={filteredProducts}
            />
            <Navigation showBack backTo="/" variant="dark" />

            <main role="main">
                <BreadCrumb className="mt-4" model={items} home={home} />
                <div className="text-center mt-4 text-2xl lg:mt-0 lg:px-0 px-4">
                    {materialFilter.length
                        ? `Вишукані прикраси із ${materialFilter
                              .map((item) => replaceMetalDesignations(item))
                              .join(", ")}`
                        : "Вишукані прикраси TSATSKY"}
                </div>

                {isLoading ? (
                    <div className="w-full text-center py-4 h-100 mt-4">
                        Loading...
                    </div>
                ) : (
                    <div className="flex flex-col lg:flex-row p-4">
                        <div className="flex lg:flex-col w-full lg:w-1/4">
                            <div className=" w-full lg:flex lg:flex-col-reverse">
                                <div className="lg:block hidden">
                                    <FilterComponent
                                        insertType={insertType}
                                        productType={productType}
                                        materialType={materialType}
                                        collectionType={collectionType}
                                        priceMinMax={priceMinMax}
                                        priceFilter={priceFilter}
                                        setPriceFilter={setPriceFilter}
                                        debouncedFilter={debouncedFilter}
                                        filterProducts={filterProducts}
                                        materialFilter={materialFilter}
                                        setMaterialFilter={setMaterialFilter}
                                        insertTypeFilter={insertTypeFilter}
                                        setInsertTypeFilter={
                                            setInsertTypeFilter
                                        }
                                        setProductTypeFilter={
                                            setProductTypeFilter
                                        }
                                        productTypeFilter={productTypeFilter}
                                        collectionTypeFilter={
                                            collectionTypeFilter
                                        }
                                        setCollectionTypeFilter={
                                            setCollectionTypeFilter
                                        }
                                    />
                                </div>

                                <div className="lg:mb-4">
                                    <AllFilterIndicators
                                        filterProducts={filterProducts}
                                        isPriceFilterActive={
                                            isPriceFilterActive
                                        }
                                        isMaterialFilterActive={
                                            isMaterialFilterActive
                                        }
                                        isInsertTypeFilterActive={
                                            isInsertTypeFilterActive
                                        }
                                        priceMinMax={priceMinMax}
                                        priceFilter={priceFilter}
                                        setPriceFilter={setPriceFilter}
                                        materialFilter={materialFilter}
                                        setMaterialFilter={setMaterialFilter}
                                        insertTypeFilter={insertTypeFilter}
                                        setInsertTypeFilter={
                                            setInsertTypeFilter
                                        }
                                        setProductTypeFilter={
                                            setProductTypeFilter
                                        }
                                        productTypeFilter={productTypeFilter}
                                        collectionTypeFilter={
                                            collectionTypeFilter
                                        }
                                        setCollectionTypeFilter={
                                            setCollectionTypeFilter
                                        }
                                        isProductTypeFilterActive={
                                            isProductTypeFilterActive
                                        }
                                        isCollectionTypeFilterActive={
                                            isCollectionTypeFilterActive
                                        }
                                    />
                                </div>

                                <div className="flex justify-end my-4 lg:hidden">
                                    <Button
                                        label="Фільтр"
                                        icon="pi pi-filter"
                                        onClick={() => setFiltersVisible(true)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div
                            className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4 mb-10 w-full lg:w-3/4 lg:mt-5 lg:ml-4 sm:gap-24 lg:p-4 lg:py-0 lg:px-10"
                            id="diamonds-catalogue"
                        >
                            {isProductsLoading ? (
                                <div className="w-full text-center py-4">
                                    Loading...
                                </div>
                            ) : (
                                filteredProducts.map((item, index) => (
                                    <ProductLuxury
                                        key={index}
                                        item={item}
                                    />
                                ))
                            )}
                        </div>
                    </div>
                )}

            </main>

            <Footer
                containerClassNames={"bg-darkgray text-harmony"}
                isDark
            />

            <Sidebar
                className={isMobile ? "" : "w-1/2"}
                position="right"
                visible={contactVisible}
                onHide={() => setContactVisible(false)}
                fullScreen={isMobile}
            >
                <ContactMeBlock />
            </Sidebar>
            <Dialog
                header="Header"
                visible={filtersVisible}
                onHide={() => {
                    if (!filtersVisible) return;
                    setFiltersVisible(false);
                }}
                maximized
            >
                <FilterComponent
                    insertType={insertType}
                    productType={productType}
                    materialType={materialType}
                    collectionType={collectionType}
                    priceMinMax={priceMinMax}
                    priceFilter={priceFilter}
                    setPriceFilter={setPriceFilter}
                    debouncedFilter={debouncedFilter}
                    filterProducts={filterProducts}
                    materialFilter={materialFilter}
                    setMaterialFilter={setMaterialFilter}
                    insertTypeFilter={insertTypeFilter}
                    setInsertTypeFilter={setInsertTypeFilter}
                    setProductTypeFilter={setProductTypeFilter}
                    productTypeFilter={productTypeFilter}
                    collectionTypeFilter={collectionTypeFilter}
                    setCollectionTypeFilter={setCollectionTypeFilter}
                />

                <div className="w-full flex justify-center">
                    <Button
                        className="mt-4 bg-blue-500 text-white py-2 px-4"
                        onClick={() => setFiltersVisible(false)}
                        label="Готово"
                    />
                </div>
            </Dialog>

        </div>
    );
}

export default Catalog;
